import React from 'react'
import AppHeader from '../../components/Header/Header'
import AppLayout from '@conponents/../../src/components/layout'
import Cursos from '../../components/SesctionService/services'
import BannerSection from '../../components/BannerSection'
import BreadcrumbNav from '../../components/BreadcrumbNav';
import SectionHeading from '../../components/SectionHeading';
import SidebarMenu from '../../components/SidebarMenu';

const caminho = [
  { label: 'Home', href: '/', icon: 'bi bi-house-door' },
  { label: 'Programa' },
  { label: 'Licenciatura' },
];

const index = () => {
  return (
    <div>
      <header id='header'>
    <AppHeader />
  </header>
   <BannerSection
      title="Licenciatura"
      subtitle="Curso de Licenciatura do ISP-Atlântida"
      description={`Os cursos de licenciatura do ISP-Atlântida são projetados para formar educadores competentes e comprometidos com a excelência acadêmica, preparando-os para atuar em diversas áreas do conhecimento.`}
      backgroundImage={require('../../assets/Licenciatura.jpg')}
      backgroundId="instituition-Banner"
  />
    <BreadcrumbNav items={caminho} />
    <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
        <br />
        <div className="row flex-row-reverse">
           <div className="col-12 col-md-4 col-lg-3 col-xl-2">
                <SidebarMenu
                    title="Programas"
                    items={[
                    { label: "Licenciatura", href: "/programas/licenciatura" },
                    { label: "Unidade Orgânica", href: "/programas/unidade-organica" },
                    ]}
                />
                </div>
            <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
            <div className="details-magazine">
                <p className="f-reg f-20">
                  <SectionHeading title="Curso de Licenciatura" />
                    <br />
                    Os cursos de licenciatura são programas acadêmicos que capacitam os estudantes a se tornarem educadores em diversas áreas do conhecimento, como Letras, Matemática, História, Biologia, Geografia, entre outras. A formação visa proporcionar aos futuros professores uma sólida base teórica e prática, com ênfase no desenvolvimento de habilidades pedagógicas, conhecimento específico da disciplina escolhida e compreensão das necessidades dos estudantes.
                    <br />
                    <br />

                    <p>
                    Esses cursos, geralmente com duração de 3 a 4 anos, preparam o aluno para atuar tanto na educação básica (ensino infantil, fundamental e médio) quanto, em alguns casos, no ensino superior. Além disso, os programas de licenciatura proporcionam uma formação completa que envolve tanto o domínio do conteúdo da área específica quanto a capacidade de transmitir esse conhecimento de maneira eficaz, inclusiva e criativa.
                    </p>

                    <br />

                    <p>
                        <strong>Escolha o seu futuro hoje:</strong> Um curso no nosso instituto superior é o primeiro passo para transformar sua paixão em uma carreira de sucesso, com conhecimento de excelência e oportunidades únicas de crescimento
                    </p>
                    
                    <br />
                    
                    </p>
                    </div>
                    <Cursos />
            </div>        
        </div>
        <br />
        <br />

    </main>
    <AppLayout />
    </div>
  )
}

export default index
